import { useMemo } from 'react'
import '@xyflow/react/dist/style.css'
import { ReactFlow, ReactFlowProvider, Background, Controls } from '@xyflow/react'

export default function ProjectMindMapSection({ mindMap }) {
  const { rfNodes, rfEdges } = useMemo(() => {
    const width = 1200
    const height = 600
    const nodes = mindMap?.nodes || []
    const edges = mindMap?.edges || []
    const centerX = width / 2
    const centerY = height / 2
    const radius = Math.min(width, height) / 2 - 100
    const computedNodes = nodes.map((n, i) => {
      const angle = nodes.length ? (i / nodes.length) * Math.PI * 2 : 0
      const x = centerX + radius * Math.cos(angle)
      const y = centerY + radius * Math.sin(angle)
      return {
        id: String(n?.id ?? i + 1),
        position: { x, y },
        data: { label: n?.label ?? n?.id ?? `Node ${i + 1}` },
        draggable: false,
        selectable: false,
        style: {
          borderRadius: 9999,
          padding: '8px 12px',
          background: 'hsl(var(--primary))',
          color: 'hsl(var(--primary-foreground))',
          border: '1px solid hsl(var(--border))',
        },
      }
    })
    const nodeIds = new Set(computedNodes.map((n) => n.id))
    const computedEdges = (edges || [])
      .map((e, i) => ({
        id: `e-${i}`,
        source: String(e?.from ?? ''),
        target: String(e?.to ?? ''),
        label: e?.label || undefined,
      }))
      .filter((e) => nodeIds.has(e.source) && nodeIds.has(e.target))
    return { rfNodes: computedNodes, rfEdges: computedEdges }
  }, [mindMap])

  const hasData = rfNodes.length > 0 || (mindMap?.edges || []).length > 0

  return (
    <section className="bg-background px-0 py-[120px]">
      <div className="mx-auto max-w-[1200px] px-[5%]">
        <h2 className="mb-8 text-center text-[clamp(2.5rem,5vw,4rem)] font-bold tracking-tight">Project Insight</h2>
        {rfNodes.length > 0 && (
          <div className="mt-10 overflow-hidden rounded-xl border border-border/50 bg-secondary">
            <div className="w-full" style={{ height: 600 }}>
              <ReactFlowProvider>
                <ReactFlow
                  nodes={rfNodes}
                  edges={rfEdges}
                  fitView
                  nodesDraggable={false}
                  nodesConnectable={false}
                  elementsSelectable={false}
                  panOnScroll
                  zoomOnScroll
                  style={{ background: 'hsl(var(--secondary))' }}
                >
                  <Background gap={24} size={1} />
                  <Controls showInteractive={false} />
                </ReactFlow>
              </ReactFlowProvider>
            </div>
          </div>
        )}
        {!hasData && <p className="text-sm text-muted-foreground">No mind map data.</p>}
      </div>
    </section>
  )
}
